export default function About({ t }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F5F1EA] py-24 lg:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#BEAF87]" />
              <span className="text-[11px] uppercase tracking-[0.35em] text-[#BEAF87] font-[Barlow_Semi_Condensed] font-medium">
                {t.about.eyebrow}
              </span>
            </div>
            <h2
              data-testid="about-title"
              className="font-[Cormorant_Garamond] font-light text-[#0A0A0A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              {t.about.title}
            </h2>
          </div>

          <div className="lg:col-span-7 lg:pt-6">
            <p
              data-testid="about-body"
              className="text-[#3a3a3a] text-lg leading-relaxed font-[Barlow_Semi_Condensed] max-w-xl"
            >
              {t.about.body}
            </p>

            <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
              {t.about.stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="relative pt-6 border-t border-[#0A0A0A]/20"
                >
                  <div className="font-[Cormorant_Garamond] text-[#0A0A0A] text-5xl lg:text-6xl font-light leading-none">
                    {s.value}
                  </div>
                  <div className="mt-3 text-[11px] uppercase tracking-[0.25em] text-[#0A0A0A]/60 font-[Barlow_Semi_Condensed]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
